const forms = document.querySelectorAll("form[data-id]");
for (const form of forms) {
    form.addEventListener("freeform-ready", function (event) {
        event.target.freeform.setOption("successBannerMessage", "Thank You");

        event.target.freeform.addOnSuccessfulAjaxSubmit(function (
            event,
            form,
            response,
        ) {
            let formWrapper = form.closest(".freeform-wrapper");
            let successMessage = formWrapper.querySelector(
                ".freeform-success-message",
            );
            let formItem = formWrapper.querySelector(".freeform-form");

            successMessage.classList.remove("hidden");
            formItem.classList.add("hidden");
            formWrapper.classList.add("s-form-submitted");
        });
    });
}
